import { format as formatDate, isValid, parseISO } from 'date-fns';

/**
 * Format a date to a string using date-fns.
 *
 * By default, the format is 'MM/dd/yyyy HH:mm'
 *
 * @example
 * // default format
 * displayDateTimeFormat(new Date()) // '01/01/2021 13:45'
 *
 * // custom format
 * displayDateTimeFormat(new Date(), 'yyyy-MM-dd') // '2021-01-01'
 *
 * @param date - The date to format
 * @param format - The format to use
 * @returns The formatted date
 */
export const displayDateTimeFormat = (
  date: Date | string | null | undefined,
  format = 'MM/dd/yyyy HH:mm',
  returnValueIfEmpty = 'N/A',
  returnValueIfInvalid = 'Invalid date',
) => {
  if (date == null) return returnValueIfEmpty;

  let dateObj: Date;
  if (typeof date === 'string') {
    // Try to parse ISO or fallback to Date constructor
    dateObj = parseISO(date);
    if (!isValid(dateObj)) {
      dateObj = new Date(date);
    }
  } else {
    dateObj = date;
  }

  if (!isValid(dateObj)) return returnValueIfInvalid;

  try {
    return formatDate(dateObj, format);
  } catch {
    return returnValueIfInvalid;
  }
};
